/* varied-checked.svg.js */

'use strict';
module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" xml:space="preserve">
            <rect x="0.5" y="0.5" class="foreground-gl"/>
            <path class="foreground-gl" d="M12,8.1H2c0,0,0,0,0,0V6c0,0,0,0,0,0H12c0,0,0,0,0,0L12,8.1C12.1,8,12.1,8.1,12,8.1z"/>
        </svg>
    `
};